<p-toast></p-toast>

<p-dialog [(visible)]="showDriverAddSideBar"
		  [baseZIndex]="10000"
		  [draggable]="false"
		  [resizable]="false"
		  (onHide)="cancel()"
		  [style]="{width:'700px'}"
		  [modal]="true">
	<ng-template pTemplate="header">
		<div style="font-weight: 700; font-size: 17px;">{{ isEditMode ? 'Edit Vehicle' : 'Add New Vehicle' }}</div>
	</ng-template>
	<div>
		<div class="flex flex-row gap-4 w-full mb-4">
			<div class="flex-1 flex-col">
				<div class="input-label required">Year</div>
				<input oninput="if(this.value.length > 4) this.value = this.value.slice(0, 4)"
					   type="number"
					   maxlength="4"
					   [(ngModel)]="vehicle.Year"
					   placeholder="Enter Year"
					   pInputText
					   [ngStyle]="{'border-color': !vehicle.Year ? 'red' : '#ced4da'}" />
				<div [ngClass]="{'error-message': !vehicle.Year}" class="error-none">
					<p>This field is required</p>
				</div>
			</div>
			<div class="flex-1 flex-col">
				<div class="input-label required">Make</div>
				<p-dropdown placeholder="e.g., BYD"
							[options]="vehicleBrands" optionLabel="NameBrand" optionValue="Id"
							(onChange)="onChangeVehicleMakeEvent($event)"
							[(ngModel)]="vehicle.BrandId"
							[showClear]="true"
							[ngClass]="{'invalid-dropdown': !vehicle.BrandId}"></p-dropdown>
				<div [ngClass]="{'error-message': !vehicle.BrandId}" class="error-none">
					<p>This field is required</p>
				</div>
			</div>
		</div>

		<div class="flex flex-row gap-4 w-full mb-4">
			<div class="flex-1 flex-col">
				<div class="input-label required">Car Model</div>
				<p-dropdown placeholder="e.g., Sealion 6"
							[options]="vehicleModels" optionLabel="NameModel" optionValue="Id"
							[(ngModel)]="vehicle.ModelId"
							[showClear]="true"
							[disabled]="!vehicle.BrandId"
							[ngClass]="{'invalid-dropdown': !vehicle.ModelId}"></p-dropdown>
				<div [ngClass]="{'error-message': !vehicle.ModelId}" class="error-none">
					<p>This field is required</p>
				</div>
			</div>
			<div class="flex-1 flex-col">
				<div class="input-label required">Chassis Number</div>
				<input type="text" [(ngModel)]="vehicle.ChassisNumber" placeholder="Enter Chassis Number" pInputText [ngStyle]="{'border-color': !vehicle.ChassisNumber ? 'red' : '#ced4da'}" />
				<div [ngClass]="{'error-message': !vehicle.ChassisNumber}" class="error-none">
					<p>This field is required</p>
				</div>
			</div>
		</div>


		<div class="flex flex-row gap-4 w-full">
			<div class="flex-1 flex-col">
				<div class="input-label required">Number Plate</div>
				<input type="text"
					   pInputText
					   [(ngModel)]="vehicle.NumberPlate"
					   [ngClass]="{'invalid-input': !vehicle.NumberPlate}"
					   class="w-full"
					   [ngStyle]="{'border-color': !vehicle.NumberPlate ? 'red' : '#ced4da'}"/>
				<div [ngClass]="{'error-message': !vehicle.NumberPlate}" class="error-none">
					<p>This field is required</p>
				</div>
			</div>
			<div class="flex-1 flex-col">
				<div class="input-label required">LTFRB Case Number</div>
				<input type="text"
					   pInputText
					   [(ngModel)]="vehicle.LTFRBCaseNumber"
					   [ngClass]="{'invalid-input': !vehicle.LTFRBCaseNumber}"
					   class="w-full"
					   [ngStyle]="{'border-color': !vehicle.LTFRBCaseNumber ? 'red' : '#ced4da'}" />
				<div [ngClass]="{'error-message': !vehicle.LTFRBCaseNumber}" class="error-none">
					<p>This field is required</p>
				</div>
			</div>
		</div>

		<hr class="hr-filter" />
		<div class="flex justify-content-end mrg-10-0px">
			<button class="p-button-text mr-3" [ngStyle]="{'color':'#004060'}" pButton label="Cancel" (click)="cancel()"></button>
			<button [disabled]="!vehicle.IsAllFieldsFilled()" class="btn-darkblue" pButton [label]="isEditMode ? 'Update Vehicle' : 'Create Vehicle'" (click)="addVehicle()"></button>
		</div>
	</div>
</p-dialog>
